import React from 'react';
import cl from './Button.module.css';

const Button = (props) => {
  return (
    <button className={cl.btn} {...props}>
        {props.children}
    </button>
  )
}

export default Button